import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/analytics';

const config = {
  apiKey: process.env.VUE_APP_API_API_KEY,
  authDomain: process.env.VUE_APP_API_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_API_DATABASE_URL,
  projectId: process.env.VUE_APP_API_PROJECT_ID,
  storageBucket: process.env.VUE_APP_API_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_API_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_API_APP_ID,
  measurementId: process.env.VUE_APP_API_MEASUREMENT_ID
};

firebase.initializeApp(config);
firebase.analytics();

Vue.prototype.firebase = firebase;
Vue.prototype.db = firebase.firestore();
Vue.prototype.firebaseFunctions = firebase.functions();
Vue.prototype.$analytics = firebase.analytics();

// Ensure app is available globally - useful for querying data not used in a view (eg. router setup, etc)
Vue.firebase = firebase;
Vue.db = firebase.firestore();
Vue.firebaseFunctions = firebase.functions();
Vue.analytics = firebase.analytics();

// export const app = firebase.app();
// export const functions = firebase.functions();
